import { display } from '../../common';
import { formatDollars } from '~/utils/formatNumber';
import { DevelopmentStages, FeeUnits, StorageFeeUnits, UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import { buyerFeeLabels, buyerStorageFeeLabels } from './buyerFeeLabels';

export function buyerFees(project: Project, projectCosts: any) {
  const { data, bid } = projectCosts || {};
  const feeData = data?.buyerFees;
  const feeLabel = buyerFeeLabels(project, feeData);
  
  if (data?.isEpcProject && feeData?.nrsFee) {
    if (feeData?.nrsFeeUnit === FeeUnits.FLAT_FEE) {
      return feeLabel;
    }
    
    if (bid || feeData?.nrsFeeUnit === FeeUnits.DOLLARS_PER_WDC) {
      return `${formatDollars(projectCosts?.overall?.nrsFee, { dec: UnitDecimals.TOTAL })} or ${feeLabel}`;
    } else {
      // on the buy side, epc project percent fees are the ONLY fees that are not calculated prior to the bid
      if (feeData?.nrsFeeUnit === FeeUnits.PERCENT_OF_ITC) {
        return `${feeLabel} - To be calculated.`;
      }
      //TODO project acquisition does not have a budget table at this time, so will just read "X% of project acquisition cost"
      if (feeData?.nrsFeeUnit === FeeUnits.PERCENT_OF_BUDGET) {
        return `${feeLabel} ${project.developmentStage === DevelopmentStages.OPERATING ? '' : '— To be calculated based on the sum of your bid, Interconnection costs, and other ITC-eligible costs in the project budget.'}`;
      }
    }
  } 
  
  if ((data?.isOfftakeProject || data?.isItcProject) && feeData?.nrsFee) {
    const feeToFormat = data?.isItcProject ? projectCosts?.itc?.nrsFee : projectCosts?.overall?.nrsFee;
    
    if (feeData?.nrsFeeUnit === FeeUnits.FLAT_FEE) {
      return feeLabel;
    } else {
      return `${formatDollars(feeToFormat, { dec: UnitDecimals.TOTAL })} or ${feeLabel}`;
    }
  } 
    
  return display(undefined);
}

export function buyerStorageFees(projectCosts: any) {
  const { data } = projectCosts || {};
  const feeData = data?.buyerFees;
  const storageFeeLabel = buyerStorageFeeLabels(feeData);
  const feeToFormat = data?.isItcProject ? projectCosts?.itc?.buyerStorageFee : projectCosts?.overall?.buyerStorageFee;

  if (feeData?.buyerStorageFee) {
    if (feeData?.buyerStorageFeeUnit === StorageFeeUnits.DOLLARS_PER_KWH) {
      return `${formatDollars(feeToFormat, { dec: UnitDecimals.TOTAL })} or ${storageFeeLabel}`;
    } else if (feeData?.buyerStorageFeeUnit === StorageFeeUnits.FLAT_FEE) {
      return storageFeeLabel;
    } 
  } else {
    return display(undefined);
  }
}